import React, { useCallback, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes, useNavigate } from 'react-router';

import HeaderColumn from '../header-column/HeaderColumn';
import HeaderLabel from '../header-label/HeaderLabel';
import HeaderAddButton from '../header-add-button/HeaderAddButton';
import { USER_ROLES } from '../../../constants';

const CustomersHeader = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('header');

  const handleAddCustomer = useCallback(() => {
    navigate('/customers/add');
  }, [navigate]);

  return (
    <HeaderColumn>
      <Routes>
        <Route
          path='/'
          element={
            <HeaderAddButton
              label={t('management')}
              onClick={handleAddCustomer}
              permissions={USER_ROLES.GLOBAL_ADMIN}
            />
          }
        />
        <Route path='/add' element={<HeaderLabel>{t('management')}</HeaderLabel>} />
        <Route path='/:id' element={<HeaderLabel>{t('management')}</HeaderLabel>} />
      </Routes>
    </HeaderColumn>
  );
};

export default memo(CustomersHeader);
